import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 17,
	viewBox: "0 0 18 17",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "search",
		d: "M16.4846 16.6538L10.2231 10.3923C9.72311 10.8179 9.14811 11.1474 8.49811 11.3808C7.84811 11.6141 7.19495 11.7308 6.53861 11.7308C4.93694 11.7308 3.58136 11.1763 2.47186 10.0675C1.36253 8.95867 0.807861 7.60392 0.807861 6.00326C0.807861 4.40242 1.36228 3.04651 2.47111 1.93551C3.57994 0.824672 4.9347 0.269257 6.53536 0.269257C8.1362 0.269257 9.49211 0.823923 10.6031 1.93326C11.7139 3.04276 12.2694 4.39834 12.2694 6.00001C12.2694 6.69484 12.1463 7.36726 11.9001 8.01726C11.6539 8.66726 11.3309 9.22301 10.9309 9.68451L17.1924 15.9463L16.4846 16.6538ZM6.53861 10.7308C7.86545 10.7308 8.98561 10.274 9.89911 9.36051C10.8126 8.44717 11.2694 7.32701 11.2694 6.00001C11.2694 4.67301 10.8126 3.55284 9.89911 2.63951C8.98561 1.72601 7.86545 1.26926 6.53861 1.26926C5.21161 1.26926 4.09144 1.72601 3.17811 2.63951C2.26461 3.55284 1.80786 4.67301 1.80786 6.00001C1.80786 7.32701 2.26461 8.44717 3.17811 9.36051C4.09144 10.274 5.21161 10.7308 6.53861 10.7308Z",
		fill: "currentColor",
		style: {
			fill: "currentColor",
			fillOpacity: 1
		}
	})
});
export default SvgSearch;
